import { combineReducers } from 'redux';
import {
  USER_LOGIN,
  GET_ELECTIONS,
  MERGE_ELECTIONS_BY_KEY,
  USER_LOGOUT
} from './actions';

const user = (state = {
  loggedIn: false,
  data: {}
}, action) => {
  switch(action.type) {
    case USER_LOGIN:
      if(action.response) {
        return {
          loggedIn: true,
          ...action.response
        }
      }
    case USER_LOGOUT:
      return {
        data: {},
        loggedIn: false
      };
    default:
      return state;
  }
}

const elections = (state = {
  default: null,
  list: [],
  byKey: {}
}, action) => {
  switch(action.type) {
    case GET_ELECTIONS:
      return {
        ...state,
        ...action.payload
      }
    case MERGE_ELECTIONS_BY_KEY: {
      const byKey = { ...state.byKey };
      const list = [...state.list];
      action.payload.forEach(election => {
        if (election && election.key) {
          byKey[election.key] = election;
          if (!list.includes(election.key)) {
            list.push(election.key);
          }
        }
      });
      return { ...state, byKey, list };
    }
    case USER_LOGOUT:
      return {
        default: null,
        list: [],
        byKey: {}
      }
    default:
      return state;
  }
}

const combinedReducers = combineReducers({
  user,
  elections,
});
export default combinedReducers;
